import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { userObj } from "../../../helper/protectedRoutes";
import axios from "../../../api/axios";

const initialState = {
    data: [],
    isLoading: null,
    status: null,
}

const token = userObj?.token;

export const getCities = createAsyncThunk(
    "customer/getCities",
    async(_, {rejectWithValue}) => {
        try {
            const response = await axios.get("Settings/Cities",
            {
                headers: {
                    Authorization: `Bearer ${token}`
                }
            });
            return response?.data
        }
        catch (err) {
            return rejectWithValue(err.response.data.title)
        }
    }
)

const getCitiesSlice = createSlice({
    name: 'getCities',
    initialState,
    reducers: {},
    extraReducers:{
        [getCities.pending]: (state, action) => {
            state.status = 'pending';
            state.isLoading = true;
        },
        [getCities.fulfilled]: (state, action) => {
            state.status = 'success';
            state.isLoading = false;
            state.data = action.payload;
        },
    
        [getCities.rejected]: (state, action) => {
            state.status = 'failed';
            state.isLoading = false;
        }
    }
})

export default getCitiesSlice.reducer
